var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('inline-menu',{staticClass:"spaced",attrs:{"links":_vm.links.top}}),_vm._v(" "),_c('inline-menu',{attrs:{"links":_vm.links.bottom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }